import {applyMiddleware, compose, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import {getWindow} from 'ssr-window';
import StorageUtils from '@spothero/utils/storage';
import createHistory from 'utils/history';
import Config from 'config';
import {analyticsMiddleware} from './middleware/analytics';
import {routerMiddleware} from './middleware/router';
import {searchRequestMiddleware} from './middleware/search-request';
import {reduxLoggerMiddleware} from './middleware/redux-logger';
import {experimentMiddleware} from './middleware/experiment';
import reducers from './reducers';
import {initialState as cityInitialState} from 'city/city-reducer';
import {initialState as destinationInitialState} from 'destination/destination-reducer';
import {initialState as eventInitialState} from 'event/event-reducer';
import {initialState as searchRequestInitialState} from 'search-request/search-request-reducer';
import {initialState as checkoutInitialState} from 'checkout/checkout-reducer';
import {initialState as pageInitialState} from 'page/page-reducer';

const window = getWindow();
let store;
const history = createHistory({basename: Config.basename});
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle
const middleware = [
    routerMiddleware(history),
    thunkMiddleware,
    promiseMiddleware,
    experimentMiddleware,
    analyticsMiddleware,
    searchRequestMiddleware,
];

if (StorageUtils.get('sh-debug-logger', 'cookie')) {
    middleware.push(reduxLoggerMiddleware);
}

export default function create(initialState) {
    store = createStore(
        reducers,
        initialState,
        composeEnhancers(applyMiddleware(...middleware))
    );

    return store;
}

export const getStore = () => store;

export const getHistory = () => history;

export function getInitialState() {
    return {
        city: cityInitialState(),
        destination: destinationInitialState(),
        event: eventInitialState(),
        searchRequest: searchRequestInitialState,
        page: pageInitialState(),
        checkout: checkoutInitialState(),
    };
}
